import { Dispatch } from "redux";
import { exportCsv, importCsv } from "../api/ProductCapabilitiesApi";
import { extractFilenameFromContentDisposition } from "../utils/buildExportFilename";
import { productCapabilitiesSlice } from "./ProductCapabilitiesSlice";

const actions = productCapabilitiesSlice.actions;

export const importProductCapabilitiesAction = (plantCode: string, file: File) => async (dispatch: Dispatch) => {
  dispatch(actions.importStarted());
  try {
    const summary = await importCsv(plantCode, file);
    if (summary.errors && summary.errors.length > 0) {
      dispatch(actions.importRejected(summary.errors));
    } else {
      dispatch(actions.importSucceeded(summary));
    }
  } catch (err: any) {
    const message = err?.response?.status
      ? `Import failed (${err.response.status}). Please try again.`
      : "Import failed. Please try again.";
    dispatch(actions.importFailed(message));
  }
};

export const exportProductCapabilitiesAction = (plantCode: string, includeInactive: boolean) => async (dispatch: Dispatch) => {
  dispatch(actions.exportStarted());
  try {
    const payload = await exportCsv(plantCode, includeInactive);
    const filename = extractFilenameFromContentDisposition(payload.contentDisposition, plantCode);

    const url = window.URL.createObjectURL(payload.blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    dispatch(actions.exportSucceeded());
  } catch (err: any) {
    const message = err?.response?.status
      ? `Export failed (${err.response.status}). Please try again.`
      : "Export failed. Please try again.";
    dispatch(actions.exportFailed(message));
  }
};

export const setIncludeInactiveAction = (value: boolean) => actions.setIncludeInactive(value);
export const clearAlertAction = () => actions.clearAlert();
